<template>
  <picture class="responsive-image">
    <template v-for="(image, idx) in imagesSorted">
      <source
        v-if="image.media"
        :srcset="image.src['#markup']"
        :media="image.media['#markup']"
        :key="idx" />
      <img
        v-if="image.alt"
        :src="image.src['#markup']"
        :alt="image.alt['#markup']"
        :key="idx"
        class="responsive-image__img"
        loading="lazy" />
    </template>
  </picture>
</template>

<script>
export default {
  name: 'responsive-image',
  props: {
    images: {
      type: [Array, Object],
      required: true,
    },
  },
  computed: {
    imagesSorted() {
      // @todo ensures that images have the right order
      // (order of items in an object can vary)

      return this.images;
    },
  },
};
</script>
